import React from "react";
import { Link } from "react-router-dom";
import cookie from "js-cookie";
import Sidebar from "../../partials/aside/Sidebar";
import AddGroupSitePublisher from "./AddGroupSitePublisher";
import actionCookie from "../../../helpers/action-cookie";
import TitleBar from "../../partials/content/TitleBar";

function AddGroupSitePublisherContainer() {
  cookie.set(
    actionCookie.REF_ENTER_ADD_GROUP_SITE_PUBLISHER,
    actionCookie.REF_ENTER_ADD_GROUP_SITE_PUBLISHER_VALUE_ADD_GROUP
  );

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <TitleBar title="اضافه کردن گروه سایت های نمایش دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link to="/publishers/all" className="btn btn-success">
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <AddGroupSitePublisher />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AddGroupSitePublisherContainer;
